(function () {

  async function init_title_banner0() {
    await MB_waitElementReady(".title_banner .title_list a");

    // 获取所有匹配的 h2 元素
    const elements = document.querySelectorAll(".title_banner .title_list a");
    const sub_title_element = document.querySelector(".title_banner .sub_title");

    // 为每个元素添加点击事件监听器
    // elements.forEach((element, index) => {
    //   element.addEventListener('click', function(e) {
    //     title_hover_handler(this);
    //   });
    // });
    // 为每个元素添加鼠标悬停事件监听器
    elements.forEach((element, index) => {
      element.addEventListener('mouseenter', function (e) {
        title_hover_handler(this);
      });
    });

    function title_hover_handler(e) {
      const sub_title = e.getAttribute('data-sub-title');
      sub_title_element.innerHTML = sub_title;
      elements.forEach(el => {
        el.classList.remove('is_selected');
      });
      e.classList.add('is_selected');
    }

    title_hover_handler(elements[0]);

  }
  async function init_title_banner() {
    await MB_waitElementReady(".title_banner .title_list a");
    const elements = document.querySelectorAll(".title_banner .title_list a");
    const total = elements.length;
    let current_index = 0;
    let last_index = -1;
    const element_out = document.querySelectorAll(".title_banner .title_list a.out");
    title_on_select(this);
    function title_on_select() {
      const e = elements[current_index];
      elements.forEach(el => {
        el.classList.remove('out');
        el.classList.remove('is_selected');
        el.classList.add('in');
      });
      e.classList.add('is_selected');
      // console.log(e)
      current_index = (current_index + 1) % total;
      setTimeout(title_on_select, 5000);
    }
    title_on_select();
  }

  async function startSeamlessScroll() {
    await MB_waitElementReady(".marquee-container ul.loop_text");
    // 使用 load 事件，确保所有的 CSS 和字体都渲染完毕后再计算宽度
    window.addEventListener('load', function () {
      const ul = document.querySelector('.loop_text');
      if (!ul) return; // 如果找不到元素则退出

      const container = document.querySelector('.marquee-container');

      // 1. 克隆内部的 HTML 节点并追加，实现无缝衔接
      ul.innerHTML += ul.innerHTML;

      // 2. 初始化变量
      let position = 0;
      const baseSpeed = 0.5; // 默认滚动速度
      let currentSpeed = baseSpeed;

      // 获取克隆后总宽度的一半（即原先真实内容的宽度）
      const halfWidth = ul.scrollWidth / 2;

      // 3. 动画渲染函数
      function scroll() {
        position -= currentSpeed; // 向左平移

        // 当向左移动的距离超过了原内容的宽度时，瞬间重置
        if (Math.abs(position) >= halfWidth) {
          position += halfWidth; // 补齐小数点的偏差，防止画面抖动
        }

        // 使用原生 API 修改 transform
        ul.style.transform = `translateX(${position}px)`;

        // 递归调用下一帧
        requestAnimationFrame(scroll);
      }

      // 启动动画
      requestAnimationFrame(scroll);

      // 4. 鼠标交互（可选）：悬停暂停，移开继续
      // container.addEventListener('mouseenter', function () {
      //   currentSpeed = 0;
      // });

      // container.addEventListener('mouseleave', function () {
      //   currentSpeed = baseSpeed;
      // });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    console.log("DOMContentLoaded")
    startSeamlessScroll()
    init_title_banner()
  })
}())